import React, { useEffect, useState } from "react";
import { Typography, Modal, Form, Input, Button, notification, Radio, Checkbox } from "antd";
import axios from "axios";
import { RegisterationUrl } from "../urls";
import { __hideLoader, __showLoader } from "../Redux Store/Slices/loader";
import { useDispatch } from "react-redux";
import setHash, { removeHash } from "../set-hash";
import useErrorHandler from "../hooks/useErrorHandler";

const RegisterationCallbackModal = ({ open = false, id, name, buttonComp = null }) => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleError = useErrorHandler();

    useEffect(() => {
        setIsModalOpen(open)
    }, [open]);
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();

    const showModal = () => {
        setIsModalOpen(true);
        setHash(name)

    };

    const handleSubmit = (values) => {
        console.log({ values })
        const data = {
            "courseName": "frontendEngineering",
            "studentName": values.name,
            "phoneNumber": values.phoneNumber,
            "email": values.email,
            "currentOccupation": values.occupation,
            collegeName: values.college_name,
            isAppliedForScholarship: values.isAppliedForScholarship
        }
        dispatch(__showLoader());
        axios.post(RegisterationUrl.register, data).then(res => {
            api.info({
                message: "Notification",
                description: "We will notify about registration on your provided phone number and email.",
                duration: 0,
            });
            form.resetFields();
            setIsModalOpen(false);
        }).catch(err => {
            // api.error({
            //     message: "Error",
            //     description: "Something went wrong!",
            //     duration: 0,
            // });
            handleError(err)
        }).finally(() => {
            dispatch(__hideLoader());
        })
        // setIsModalOpen(false);
        // form.resetFields(); // Reset the form after submission

    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields(); // Reset the form on cancel
        removeHash();
    };

    return (
        <div>
            {contextHolder}
            <div className="" onClick={showModal}>
                {buttonComp}
            </div>
            <Modal
                title={`Enroll Now in ${name}`}
                open={isModalOpen}
                onCancel={handleCancel}
                okText="Send"
                cancelText="Cancel"
                footer={null} // Use custom footer to avoid default buttons interfering with the form
            >
                <Form
                    form={form}
                    layout="vertical"
                    name="registration_form"
                    onFinish={handleSubmit} // Move onFinish here
                >
                    <div className="max-h-[60vh] overflow-auto"
                    >

                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[
                                { required: true, message: "Please enter your name" },
                                { min: 2, message: "Name must be at least 2 characters" },
                            ]}
                        >
                            <Input placeholder="Enter your name" />
                        </Form.Item>
                        <Form.Item
                            label="Phone Number"
                            name="phoneNumber"
                            rules={[
                                { required: true, message: "Phone number is required" },
                                {
                                    pattern: /^\+?[1-9]\d{1,14}$/,
                                    message: "Enter a valid phone number (e.g., +1234567890)",
                                },
                            ]}
                        >
                            <Input placeholder="Enter your phone number with country code" />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Please enter your email" },
                                {
                                    type: "email",
                                    message: "Please enter a valid email address",
                                },
                            ]}
                        >
                            <Input placeholder="Enter your email" />
                        </Form.Item>
                        <Form.Item label="College Name" name="college_name">
                            <Input placeholder="Enter your College Name" />
                        </Form.Item>
                        <Form.Item
                            label="Current Occupation"
                            name="occupation"
                            rules={[{ required: true, message: "Please select your current occupation" }]}
                        >
                            <Radio.Group>
                                <Radio value="working">Working</Radio>
                                <Radio value="student">Student</Radio>
                                <Radio value="unemployed">Unemployed</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item name="isAppliedForScholarship" valuePropName="checked">
                            <Checkbox>Applying for Scholarship</Checkbox>
                        </Form.Item>
                        <Typography.Text className="text-sm text-gray-600 mt-3">
                            We will notify about registration on your provided phone number and email.
                        </Typography.Text>
                    </div>

                    <Form.Item className="flex justify-end pt-5" >
                        <Button type="primary" htmlType="submit" className="ml-auto" >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

        </div>
    );
};

export default RegisterationCallbackModal;